// extracted by mini-css-extract-plugin
export default {"cls1":"SimplePaperPodcast-cls1_wVk","cls2":"SimplePaperPodcast-cls2_lUU SimplePaperPodcast-cls1_wVk"};